import React, { useState, useRef, useEffect } from "react";
import {
  Notifications,
  VideoFile,
  AccountCircle,
  Search,
  Logout,
  Settings,
  Person
} from "@mui/icons-material";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  const email = user?.email;

  // 🔐 fermer le menu si clic extérieur
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <header className="header">
      {/* LOGO */}
      <div className="logo">
        <img
          src={`${process.env.PUBLIC_URL}/images/mobing.png`}
          alt="Mobing"
        />
        <h1 className="h1-titre">| Studio</h1>
      </div>

      {/* SEARCH */}
      <div className="search-bar">
        <input type="text" placeholder="Rechercher..." />
        <button>
          <Search />
        </button>
      </div>

      {/* ACTIONS */}
      <div className="icons">
        <VideoFile titleAccess="Mes vidéos" />
        <Notifications titleAccess="Notifications" />

        <span className="user-email">{email}</span>

        {/* AVATAR */}
        <div className="account" ref={menuRef}>
          <AccountCircle
            className="account-icon"
            onClick={() => setOpen(!open)}
          />

          {/* MENU DROPDOWN */}
          {open && (
            <div className="account-menu">
              <button onClick={() => navigate("/profile")}>
                <Person />
                <span>Mon compte</span>
              </button>

              <button onClick={() => navigate("/settings")}>
                <Settings />
                <span>Paramètres</span>
              </button>

              <hr />

              <button className="logout" onClick={handleLogout}>
                <Logout />
                <span>Déconnexion</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
